import { defineAction } from '~/prix'
import healthProfessionalListAction from './healthProfessionalList.action.json' with { type: 'json' }
import { actionListInput, actionListOutput } from '~/utils/shared/paginatedModalListConfig'
import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import { string } from '~/prix/types/zodType'

const healthProfessionalListDefinition = defineAction({
  ...healthProfessionalListAction,

  input: actionListInput({}),
  output: actionListOutput(
    z.array(
      z.object({
        originalId: z.string().nullish(),
        dataSourceId: z.string().nullish(),
        cns: z.string().nullish(),
        name: string().meta({ isTitle: true }).nullish(),
        cbo: z.string().nullish(),
        cnes: z.string().nullish(),
        longitude: z.number().nullish(),
        latitude: z.number().nullish(),
        team_ine: z.string().nullish(),
        phoneNumber: z.string().nullish(),
        createdAt: dateOrIsoString().nullish(),
        updatedAt: dateOrIsoString().nullish(),
        isDeleted: z.boolean().nullish(),
      }),
    ),
  ),
})

export default healthProfessionalListDefinition
